import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { adalApiFetch } from './../store/adalConfig';

export default class MaterialGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            gridColumns: this.props.gridColumns,
            gridCaption: this.props.gridCaption,
            gridParams: this.props.gridParams,
            gridAjax: this.props.ajax,
        };

        this.getLotTransactionEvents(this.props.gridAjax, this.props.gridParams);
    }

    handleStateChange = (key, value) => {
        this.setState({ ...this.state, [key]: value });
    }

    getLotTransactionEvents = (ajax, params) => {
        if (ajax === null || params === null)
            return;

        let url = ajax + "?";
        for (var key in params)
        {
            let value = params[key];
            if (key !== null && value !== null)
                url += key + "=" + encodeURI(value) + "&"; 
        }

        adalApiFetch(fetch, url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    ...this.state,
                    rows: data
                });
            });
    }

    render() {
        return (          
            <div>
                <label htmlFor="grid" id="lbCaption">{this.state.gridCaption}</label>&nbsp;
                <ReactDataGrid grid
                    columns={this.state.gridColumns}
                    rowGetter={i => this.state.rows[i]}
                    rowsCount={this.state.rows.length}
                    enableCellSelect={false}
                    ref={grid => this.grid = grid}
                    rowHeight={34}
                />
             </div>
        );
    }
}